module.exports = __webpack_public_path__ + "static/ab9-6d63dbf332c0d00a17522949f9dc6685.jpg";